import classNames from 'classnames';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { RequiredWrapper } from '../../../core/formValidation';
import DateTimePicker from '../../../core/components/DateTimePicker';
import Detergent from '../models';

export const DetergentReadingEditFields = (props) => {
  const { detergents, name = 'readings', control: controlProp, watch: watchProp } = props;
  const ctx = useFormContext ? useFormContext() : null;
  const control = controlProp || (ctx && ctx.control);
  const watch = watchProp || (ctx && ctx.watch);
  if (!control || !watch) {
    return <React.Fragment />;
  }
  const { fields, append, remove } = useFieldArray({ control, name });

  const getRemainingDetergents = (currentIndex) => {
    const values = watch(name) || [];
    const selectedIds = values
      .map((v, idx) => (idx === currentIndex ? null : v && v.detergentId))
      .filter((id) => !!id);
    return detergents.filter((d) => !selectedIds.includes(d.id));
  };

  return (
    <React.Fragment>
      {fields.map((field, index) => {
        const remaining = getRemainingDetergents(index);
        const currentId = watch(`${name}.${index}.detergentId`);
        const selected = detergents.find((d) => d.id === currentId);

        return (
          <div key={field.id} className="field-row">
            <div className="field-row-heading">
              <p>{`Reading #${index + 1}`}</p>
              <button
                type="button"
                className={classNames('close', 'no-float', 'multi-form-delete')}
                onClick={() => remove(index)}
              >
                <i className="icon icon-squared-cross" />
              </button>
            </div>
            <div className="form-group">
              <RequiredWrapper value={currentId}>
                <Controller
                  name={`${name}.${index}.detergentId`}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <select
                      id="detergentId"
                      className="form-control"
                      value={value || ''}
                      onChange={(e) => onChange(Number(e.target.value))}
                    >
                      <option value="">Choose Detergent...</option>
                      {selected && (
                        <option id="selected" value={selected.id}>
                          {selected.name}
                        </option>
                      )}
                      {remaining.map((d) => (
                        <option id="remaining" key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </select>
                  )}
                />
              </RequiredWrapper>
            </div>
            <div className="form-group">
              <RequiredWrapper value={watch(`${name}.${index}.value`)}>
                <Controller
                  name={`${name}.${index}.value`}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <input
                      className="form-control"
                      id="value"
                      type="number"
                      aria-describedby="descriptionHelp"
                      placeholder="Gallons Left"
                      value={value || ''}
                      onChange={(e) => onChange(e.target.value)}
                    />
                  )}
                />
              </RequiredWrapper>
            </div>
            <div className="form-group">
              <RequiredWrapper value={watch(`${name}.${index}.timestamp`)}>
                <Controller
                  name={`${name}.${index}.timestamp`}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <DateTimePicker
                      placeholderText={`${moment(Date.now()).format('MM/DD/YY h:mm a')}`}
                      showToday
                      timeProps={{
                        showTimeSelect: true,
                        timeFormat: 'hh:mm aa',
                        timeIntervals: 15,
                        dateFormat: 'MM/dd/YYY h:mm aa',
                        timeCaption: 'Time',
                      }}
                      input={{ value, onChange }}
                    />
                  )}
                />
              </RequiredWrapper>
            </div>
          </div>
        );
      })}
      <button
        type="button"
        className={classNames('button', 'full-width', 'add-reading')}
        onClick={() => {
          const remaining = getRemainingDetergents(-1);
          const firstId =
            (remaining[0] && remaining[0].id) || (detergents[0] && detergents[0].id) || '';
          append({ detergentId: firstId, value: '', timestamp: null });
        }}
      >
        Add Reading
      </button>
    </React.Fragment>
  );
};

DetergentReadingEditFields.propTypes = {
  detergents: PropTypes.arrayOf(PropTypes.instanceOf(Detergent)),
  name: PropTypes.string,
};

export default DetergentReadingEditFields;
